import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable } from 'rxjs';
import { UtilService } from 'src/app/shared/utils/utils.service';
import { DocumentBatchApi } from '../../APIs/documents/document-batch.api';
import { DocumentBatchEntity } from '../../entities/document-batch.entity';
import { DomainTranslateService } from '../../utils/domain-translate.service';

@Injectable({
    providedIn: 'root',
})
export class DocumentBatchController {
    // * [API]
    private _api = inject(DocumentBatchApi);

    // * [Injects]
    private _utilService = inject(UtilService);
    private _i18n = inject(DomainTranslateService);

    /**
     * O erro sobe tratado com toast: sem saldo a API responde 402, e o pacote inteiro
     * não acontece — é a única mensagem que o usuário precisa ver nesse caso.
     */
    public create(orderId: string, documentIds: string[]): Observable<DocumentBatchEntity> {
        return this._api.create(orderId, documentIds).pipe(
            map(response => response.body),
            catchError(error =>
                this._utilService.handleError(
                    error,
                    this._i18n.instant('domain.documentBatch.errors.create')
                )
            )
        );
    }

    public getById(id: string): Observable<DocumentBatchEntity> {
        return this._api.getById(id).pipe(
            map(response => response.body),
            catchError(error =>
                this._utilService.handleError(
                    error,
                    this._i18n.instant('domain.documentBatch.errors.load')
                )
            )
        );
    }

    public getCurrentByOrder(orderId: string): Observable<DocumentBatchEntity | null> {
        return this._api.getCurrentByOrder(orderId).pipe(
            map(response => response.body),
            catchError(error =>
                this._utilService.handleError(
                    error,
                    this._i18n.instant('domain.documentBatch.errors.load')
                )
            )
        );
    }

    public getDownloadUrl(id: string): Observable<{ url: string }> {
        return this._api.getDownloadUrl(id).pipe(
            map(response => response.body),
            catchError(error =>
                this._utilService.handleError(
                    error,
                    this._i18n.instant('domain.documentBatch.errors.download')
                )
            )
        );
    }

    public skipItem(id: string, documentId: string): Observable<DocumentBatchEntity> {
        return this._api.skipItem(id, documentId).pipe(
            map(response => response.body),
            catchError(error =>
                this._utilService.handleError(
                    error,
                    this._i18n.instant('domain.documentBatch.errors.skipItem')
                )
            )
        );
    }

    public retryItem(id: string, documentId: string): Observable<DocumentBatchEntity> {
        return this._api.retryItem(id, documentId).pipe(
            map(response => response.body),
            catchError(error =>
                this._utilService.handleError(
                    error,
                    this._i18n.instant('domain.documentBatch.errors.retryItem')
                )
            )
        );
    }

    public cancel(id: string): Observable<void> {
        return this._api.cancel(id).pipe(
            map(response => response.body),
            catchError(error =>
                this._utilService.handleError(
                    error,
                    this._i18n.instant('domain.documentBatch.errors.cancel')
                )
            )
        );
    }
}
